import React from "react"
import { useOutletContext } from "react-router-dom"
import { Typography } from "antd"

import Identity from "@components/Identity"
import FormattedValue from "@components/FormattedValue"

const LABEL_SUMMARY = "Summary"
const LABEL_OPERATION = "Activity"
const LABEL_CREATED_BY = "Created By"


const useColumnsConfig = (table, openActivityDrawer) => {
  const { computeUserFullname, computeAccountFullname } = useOutletContext()

  const computeFullname = (id) =>
    id.startsWith("ACC_")
      ? computeAccountFullname(id)
      : computeUserFullname(id)

  const operationColumnProps = {
    key: "operationId",
    title: LABEL_OPERATION,
    compute: ({ operationId }) => operationId,
    render: (value, { id }) =>
      <Typography.Link strong onClick={() => openActivityDrawer(id)}>
        {value}
      </Typography.Link>,
    isSearchable: true,
    isFilterEnabled: true,
  }

  const operationIdColumnProps = {
    key: "operationId",
    title: LABEL_SUMMARY,
    compute: activity => table.current.renderActivity(activity),
    isSearchable: true,
  }

  const createdByColumnProps = {
    key: "userId",
    title: LABEL_CREATED_BY,
    compute: ({ userId }) => computeFullname(userId),
    render: (fullname, { userId }) =>
      <Identity id={userId}>{fullname}</Identity>,
    isSearchable: true,
  }

  const createdAtColumnProps = {
    key: "createdAt",
    render: value =>
      <FormattedValue value={value} />
  }

  return [
    { ...operationColumnProps, width: "auto", widthAutoPadding: 30 },
    { ...operationIdColumnProps },
    { ...createdByColumnProps, width: "auto", widthAutoPadding: 40 },
    { ...createdAtColumnProps, width: 160 }
  ]
}

export default useColumnsConfig
